import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {BaseViewElement} from '../base-view-element';
import {PropertySet} from '../../../core/model/helper-models/property-set.model';
import {Property} from '../../../core/model/helper-models/property.model';

@Component({
    selector: 'app-olps-orders',
    templateUrl: './olps-orders.component.html',
    styleUrls: ['./olps-orders.component.scss',
        './../card.scss'],
    standalone: false
})
export class OlpsOrdersComponent extends BaseViewElement implements OnInit, OnChanges
{
    @Input() Orders: PropertySet;
    @Input() Movements: PropertySet;

    OrdersHour: Property<any>;
    OrdersTotal: Property<any>;
    HubCycles: Property<any>;

    constructor()
    {
        super('olps-orders');
    }

    onResize(result: any)
    {
        this.childResizeEvent.emit();
    }

    ngOnChanges(changes: SimpleChanges): void
    {
        if (this.Orders == null || this.Movements == null)
        {
            return;
        }

        this.OrdersHour = this.Orders.properties.get('ORDERS_PER_HOUR');
        this.OrdersTotal = this.Orders.properties.get('ORDERS_TOTAL');
        this.HubCycles = this.Movements.properties.get('LHD_CYCLES');
    }


}
